import React, { FunctionComponent, SVGProps } from 'react';
import styled from 'styled-components';

interface EditIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const EditIcon: FunctionComponent<EditIconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg viewBox="0 0 12 12" className={className || ''} {...props}>
      <Path
        fillRule="evenodd"
        d="M7.13,.35L.9,6.6,.04,10.53c-.23,.83,.61,1.67,1.44,1.44l3.95-.85,6.21-6.25c.48-.45,.48-1.26,0-1.71L8.82,.35c-.44-.47-1.25-.47-1.69,0ZM2.42,10.65l-1.06-1.06,.54-2.47,3,2.99-2.48,.54Z"
      />
    </svg>
  );
};

export default styled(EditIcon)`
  width: 12px;
  height: 12px;
`;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.primary};
`;
